import { render, staticRenderFns } from "./ProductanalysisHandle.vue?vue&type=template&id=6a395077&scoped=true&"
import script from "./ProductanalysisHandle.vue?vue&type=script&lang=js&"
export * from "./ProductanalysisHandle.vue?vue&type=script&lang=js&"
import style0 from "./ProductanalysisHandle.vue?vue&type=style&index=0&id=6a395077&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a395077",
  null
  
)

export default component.exports